import React, { useState } from "react";

/// React router dom
import { Link } from "react-router-dom";

/// images
import logo from "../../../images/logo.png";
import logoText from "../../../images/logo-text.png";

export function NavMenuToggle() {
    setTimeout(() => {
        let mainwrapper = document.querySelector("#main-wrapper");
        if (mainwrapper.classList.contains('menu-toggle')) {
            mainwrapper.classList.remove("menu-toggle");
        } else {
            mainwrapper.classList.add("menu-toggle");
        }
    }, 200);
}

function getLogoRoute() {
    try {
        const parsed = JSON.parse(localStorage.getItem("userDetails") || "{}");
        const roleName = (parsed?.roleId?.roleName || parsed?.roleName || "").toLowerCase();
        return roleName === "employees" ? "/employee-view" : "/dashboard";
    } catch {
        return "/dashboard";
    }
}

const NavHader = () => {
    const [toggle, setToggle] = useState(false);

    return (
        <div className="nav-header">
            <Link to={getLogoRoute()} className="brand-logo">
                <img className="logo-abbr" src={logo} alt="Logo" />
                <img className="logo-compact" src={logoText} alt="Logo" />
                <img className="brand-title" src={logoText} alt="Logo" />
            </Link>

            <div className="nav-control" onClick={() => {
                setToggle(!toggle)
                NavMenuToggle();
            }}
            >
                <div className={`hamburger ${toggle ? "is-active" : ""}`}>
                    <span className="line"></span>
                    <span className="line"></span>
                    <span className="line"></span>
                </div>
            </div>
        </div>
    );
};

export default NavHader;
